import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { injectGlobal } from 'styled-components';

import { OriginThemeProvider, TrackingProvider } from '@origin-digital/ods-core';
import { SharedAppContextV2Provider } from '@origin-digital/shared-app-context';
import { trackingProviderCaptureClick } from '@origin-digital/reporting-client';
import { parseMarkdownEvent } from '@origin-digital/event-dispatcher';

import { App } from 'src/components/App';
import { ErrorWrapper } from 'src/components/ErrorWrapper';

declare const __DEV__: boolean;

if (__DEV__) {
  // eslint-disable-next-line babel/no-unused-expressions
  injectGlobal`
    html {
      background-color: #f1f1f1;
      height:100%;
    }

    body {
      margin: 0;
      font-family: gordita, sans-serif;
      height: 100%;
    }

    #oetal-application-dev-plugin {
      height: 100%;
    }
  `;
}

const MeshLink = React.forwardRef<any, any>((props, ref) => {
  const { href, onClick } = parseMarkdownEvent(props.href);
  return (
    <a ref={ref} {...props} href={href} onClick={onClick}>
      {props.children}
    </a>
  );
});

export const Root = withRouter((props: RouteComponentProps) => (
  <OriginThemeProvider linkComponent={MeshLink}>
    <TrackingProvider onTrackingCapture={trackingProviderCaptureClick}>
      <ErrorWrapper>
        <SharedAppContextV2Provider xhrInitialize={__DEV__}>
          <App {...props} />
        </SharedAppContextV2Provider>
      </ErrorWrapper>
    </TrackingProvider>
  </OriginThemeProvider>
));
